import {
  AttributeName,
  TreatmentType,
  Score,
} from "@keita/lanepatrol-sdk";
import { ResultsFilters } from "../../map/models/MapFilters";
import { Treatment } from "../../osaway/models/OsaNode";
import { ScoreImpact } from "../../coding/models/ScoreImpact";

type wayAndNodeId = string;

export interface ForecastScenario {
  id: string;
  projectId: string;
  name: string;
  changes: ForecastChange[];
  createdAt: string;
  createdById: string;
}

export interface ForecastChangeRequest {
  action: ForecastAction;
  filters: ResultsFilters;
}

export interface ForecastChange extends ForecastChangeRequest {
  results?: Map<wayAndNodeId, SimulatedResult>;
}

export type ForecastAction =
  | {
      type: ForecastActionType.HighestPriorityTreatment;
    }
  | {
      type: ForecastActionType.TreatmentWhenSuggested;
      treatmentType: TreatmentType;
    }
  | {
      type: ForecastActionType.AttributeValues;
      attributeValues: { [key in AttributeName]?: string };
    };

export enum ForecastActionType {
  HighestPriorityTreatment = "HighestPriorityTreatment",
  TreatmentWhenSuggested = "TreatmentWhenSuggested",
  AttributeValues = "AttributeValues",
}

export interface SimulatedResult {
  score: Score;
  scoreImpact: ScoreImpact;
  treatments: Treatment[];
}

export interface CreateForecastScenarioRequest {
  projectId: string;
  name: string;
  changes: ForecastChangeRequest[];
}

export interface UpdateForecastScenarioRequest {
  name: string;
  changes: ForecastChangeRequest[];
}
